import { LegalPageLayout, useLegalDocument } from "@/components/LegalPageLayout";

const TermsOfService = () => {
  const document = useLegalDocument("terms");
  return <LegalPageLayout document={document} />;
};

export default TermsOfService;
